import { useContext } from 'react';

import { UserContext } from '../context';


export const useUser = () => {
  const user = useContext(UserContext);

  return { user };
};
